export enum Tabs {
    "TextQuery",
    "PlotQuery"
}